import React from 'react'
import {
  Button,
  Columns,
  Container,
  Heading,
  Loader,
  Section,
  Form as BulmaForm,
} from 'react-bulma-components'
import Layout from '../../components/layout/layout'
import { useOrganizationsQuery } from '../../queries/organizations'
import useStore from '../../store'
import { Navigate } from 'react-router-dom'
import { useAuthMutation } from 'src/queries/users'
import { Formik, Form } from 'formik'

const LoginAsQrScannerUserPage: React.FC = () => {
  const currentUser = useStore(s => s.session.currentUser)
  const currentUserRole = useStore(s => s.session.currentUserRole)
  const isSuperAdmin = useStore(s => s.session.isSuperAdmin)
  const loggedAs = useStore(s => s.session.loggedAs)
  const changeCurrentRole = useStore(s => s.session.changeCurrentRole)

  const allEmployers = useOrganizationsQuery()?.data?.filter(o => o.type === 'employer')
  const authMutation = useAuthMutation()

  const notAuthorized = allEmployers?.length === 0
  const isSystemUser = currentUser?.appAccess === 'system'

  // First but first, we are already loggged, all terminals point to /kiosk
  // -> For login
  // -> But also for scan
  // If already logged as system user, we just forward to the laser
  if (isSystemUser) return <Navigate to="/laser-scanner" />

  // Here we are configuring a terminal
  // Due to the way sessions initialize, Super Admins user might have their
  // current user role set to an organization they are part of
  // Super Admins need the full employers list, so we force change current role
  // The only case allowed is being a Super Admin and using the "login as" feature
  if (isSuperAdmin && !loggedAs && currentUserRole !== 'superAdmin') {
    const superAdminRole = currentUser?.roles.find(role => role.kind === 'superAdmin')
    superAdminRole && changeCurrentRole(superAdminRole)
  }

  if (allEmployers === undefined) return <Loader />

  return (
    <Layout>
      <Section size={'large'}>
        <Container>
          <Columns centered>
            <Columns.Column size={4}>
              <Heading>Créer une Borne de Scan</Heading>
              <>
                {notAuthorized ? (
                  <>Vous n'êtes pas autorisé à créer une Borne de Scan</>
                ) : (
                  <>
                    <Container my={5} mb={6}>
                      <Formik
                        initialValues={{
                          loginAsQrScannerForEmployerId: allEmployers?.[0]?._id,
                        }}
                        enableReinitialize
                        onSubmit={async ({ loginAsQrScannerForEmployerId }) => {
                          authMutation.mutate({ loginAsQrScannerForEmployerId })
                        }}
                      >
                        {props => {
                          return (
                            <Form>
                              <BulmaForm.Field>
                                <BulmaForm.Label>Employeur pour la Borne de Scan ?</BulmaForm.Label>
                                <BulmaForm.Control>
                                  {allEmployers?.map(e => {
                                    return (
                                      <>
                                        <BulmaForm.Radio
                                          key={e._id}
                                          name={e._id}
                                          checked={
                                            props.values.loginAsQrScannerForEmployerId === e._id
                                          }
                                          value={e._id}
                                          onChange={() =>
                                            props.setFieldValue(
                                              'loginAsQrScannerForEmployerId',
                                              e._id,
                                            )
                                          }
                                        >
                                          {e.name}
                                        </BulmaForm.Radio>
                                        <br />
                                      </>
                                    )
                                  })}
                                </BulmaForm.Control>
                              </BulmaForm.Field>
                              <Button type="submit" mt={5}>
                                Créer un Kiosque
                              </Button>
                            </Form>
                          )
                        }}
                      </Formik>
                    </Container>
                  </>
                )}
              </>
            </Columns.Column>
          </Columns>
        </Container>
      </Section>
    </Layout>
  )
}

export default LoginAsQrScannerUserPage
